import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 331px;
  height: 101px;
  padding: 24px;

  background: #ffffff;
  border-radius: 8px;

  font-family: 'Roboto', sans-serif;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 50%;
    height: 100%;
    padding-top: 24px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 24px;
    margin-bottom: 16px;
  }
`;

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #6d787d;
`;

export const Content = styled.div`
  width: 100%;
  height: 22px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31.2px;
  color: #000000;
  margin-top: 9px;
`;
